import React, { useEffect, useState } from "react";
import "./ServiceDetails.css";
import { useParams, useNavigate } from "react-router-dom";
import ConsultationModal from "../../components/ConsultationModal/index.js";
import { FiCheckCircle } from "react-icons/fi";
import Footer from "../../components/Footer/index.js";
import Gap1 from "../../assets/Images/GapAnalysis1.png";

const ServiceDetails = () => {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const cleanHTML = (text) => {
    if (!text) return "";

    return text
      .replace(/<(?!\/?(b|strong)\b)[^>]*>/gi, "") // keep <b>, <strong>
      .replace(/&nbsp;/g, " ");
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (!slug || slug === "undefined") return;

    fetch(`${BASE_URL}service/${slug}`)
      .then((res) => res.json())
      .then((data) => setService(data.data))
      .catch((err) => console.log(err));
  }, [slug]);

  if (!service) {
    return <p style={{ textAlign: "center" }}>Loading...</p>;
  }

  return (
    <div>
      <section className="gap-section">
        <div className="gap-container">
          <h2 class="text-white">{service.title}</h2>

          {service.content1 && (
            // <p
            //   className="gap-description"
            //   dangerouslySetInnerHTML={{ __html: service.content1 }}
            // />
            <p class="gap-description text-white"
              dangerouslySetInnerHTML={{
                __html: cleanHTML(service.content1),
              }}
            />
          )}
        </div>
      </section>

      <section className="service-overview-section">
        <div className="service-container">
          <div className="service-image">
            <img
              src={service.image || ""}
              alt={service.title}
              style={{ display: service.image ? "block" : "none" }}
            />
            {/* <img src={service.image || Gap1} alt={service.title} /> */}
          </div>

          <div className="service-content">
            <h2>Service Overview</h2>


            {service.content2 && (
              <p dangerouslySetInnerHTML={{ __html: service.content2 }} />
            )}
            <button
              className="consult-btn-servises"
              onClick={() => setShowModal(true)}
            >
              Get Consultation <span className="btn-icon">💬</span>
            </button>
          </div>
        </div>
      </section>

      {service.features?.length > 0 && (
        <section className="features-section">
          <div className="features-container">
            <h2 className="features-title">Key Features</h2>

            <div className="features-grid">
              {service.features.map((item, i) => {
                const title = typeof item === "string" ? item : item.title;
                const description = typeof item === "string" ? item : item.description;

                const icon =
                  typeof item === "object" && item.icon
                    ? item.icon
                    : "https://cdn-icons-png.flaticon.com/512/190/190411.png";

                return (
                  <div key={i} className="feature-card">
                    <img src={icon} alt="icon" className="feature-icon" />
                    <p><b>{title}: </b>{description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {service.process_steps?.length > 0 && (

        <section className="benefits-section">
          <div className="benefits-wrapper">
            {service.benefits?.length > 0 && (
              <div className="benefits-column">
                <div class="d-flex align-items-center">
                  <div class="sec-title-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M15.4768 12.89L16.9918 21.416C17.0087 21.5164 16.9946 21.6196 16.9514 21.7118C16.9081 21.8039 16.8377 21.8807 16.7497 21.9318C16.6616 21.9829 16.56 22.0059 16.4586 21.9977C16.3571 21.9895 16.2605 21.9506 16.1818 21.886L12.6018 19.199C12.4289 19.0699 12.219 19.0001 12.0033 19.0001C11.7875 19.0001 11.5776 19.0699 11.4048 19.199L7.81875 21.885C7.74007 21.9494 7.64361 21.9883 7.54225 21.9965C7.44088 22.0047 7.33942 21.9818 7.25141 21.9309C7.16341 21.8799 7.09303 21.8033 7.04967 21.7113C7.00631 21.6193 6.99204 21.5163 7.00875 21.416L8.52275 12.89" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M12 14C15.3137 14 18 11.3137 18 8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8C6 11.3137 8.68629 14 12 14Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <h3>Benefits</h3>
                </div>
                <ul className="benefits-list">
                  {service.benefits.map((item, i) => (
                    <li key={i} className="d-flex gap-2">
                      <span class="benefits-icon-svg"><FiCheckCircle className="li_Icon" /></span>
                      <span class="benefits-section-desc"><b>{item.title}: </b>{item.description}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {service.who_needs?.length > 0 && (
              <div className="benefits-column">
                <div class="d-flex align-items-center">
                  <div class="sec-title-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M22 21V19C21.9993 18.1137 21.7044 17.2528 21.1614 16.5523C20.6184 15.8519 19.8581 15.3516 19 15.13" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <h3>Who Needs This</h3>
                </div>


                <ul className="benefits-list-2">
                  {service.who_needs.map((item, i) => (
                    <li key={i}
                      dangerouslySetInnerHTML={{
                        __html: cleanHTML(item),
                      }}
                    />
                  ))}
                </ul>
              </div>
            )}
          </div>
        </section>
      )}

      {service.process_steps?.length > 0 && (
        <section className="process-section">
          <h2 className="process-heading">Our Process</h2>

          <div className="process-grid">
            {service.process_steps.map((step, i) => (
              <div key={i} className="process-card">
                <div className="process-number">{step.step_no}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      <section className="cta-section">
        <div className="cta-container">
          <h2>Ready to Get Started?</h2>

          <p>
            Contact us today for a free consultation and learn how our service
            can help your organization
          </p>

          <div className="cta-buttons">
            <button className="cta-primary" onClick={() => setShowModal(true)}>
              Get Free Consultation
            </button>

            <button
              className="cta-outline"
              onClick={() => navigate("/Services")}
            >
              View All Services →
            </button>
          </div>
        </div>
      </section>

      {showModal && (
        <ConsultationModal
          show={showModal}
          onClose={() => setShowModal(false)}
        />
      )}

      <Footer />
    </div>
  );
};

export default ServiceDetails;
